import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/14.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Po wizycie u szewca – do zduna"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p30,
            }}
            content={
                <div>
                    <p>
                    Podchodzisz do warsztatu z ceramicznymi kaflami, ale ledwo wyciągasz rękę, żeby zapukać, drzwi się otwierają, a z izby wypada dwóch wesołych mężczyzn.
                    </p>
                    <ul>
                        <li>Dzień dobry, może szukacie kogoś do pracy? Kantor… – zanim udaje ci się dokończyć, przerywa ci starszy mężczyzna w kaszkiecie:</li>
                        <li>Do pracy, hę? Do Zagórowa musiałoby się sprowadzić drugie tyle ludzi co teraz, żeby nam starczyło do podziału, a jeszcze każdy z nich musiałby u nas piec kaflowy zamówić… A potem trzymaj kciuki człowieku, żeby się psuły, bo i z tego jest pieniądz, ale żeby się nie za bardzo też psuły, bo w końcu ty ten piec robiłeś!</li>
                        <li>Dwóch zdunów, cztery ręce do roboty i wystarczy. Trzy osoby dobre, jakbyśmy partię zakładali. Nie da rady – stwierdza młodszy, zerkając na ciebie niepewnie.</li>
                        <li>Robota czeka, jedziemy z tą robotą! – pogania starszy zdun i krzyczy zza pleców: – A dla ciebie, chłopcze, powodzenia!</li>
                    </ul>
                </div>
            }
        />

    );
}